import { useCallback, useEffect, useState } from 'react';

import { ColorMode } from '../theme';

const STORAGE_KEY = 'kudable_color_mode';
const DARK_CLASS = 'dark';

const readSystemPreference = (): ColorMode => {
  if (typeof window === 'undefined' || !window.matchMedia) return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
};

const readStored = (): ColorMode | null => {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === 'light' || raw === 'dark' ? raw : null;
};

export const useColorMode = () => {
  const [mode, setMode] = useState<ColorMode>(
    () => readStored() ?? readSystemPreference(),
  );

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, mode);
    if (mode === 'dark') {
      document.body.classList.add(DARK_CLASS);
    } else {
      document.body.classList.remove(DARK_CLASS);
    }
  }, [mode]);

  const toggle = useCallback(() => {
    setMode((current) => (current === 'dark' ? 'light' : 'dark'));
  }, []);

  return { mode, setMode, toggle };
};
